// extracted by mini-css-extract-plugin
export default {"container":"dialogs-list_container__+imUf","main":"dialogs-list_main__1+lZO"};